import {
  GET_LABREQUESTCALENDAR,
  GET_LABREQUESTCALENDAR_FAIL,
  GET_LABREQUESTCALENDAR_SUCCESS,
  GET_LABREQUESTCALENDARS,
  GET_LABREQUESTCALENDARS_FAIL,
  GET_LABREQUESTCALENDARS_SUCCESS,
  ADD_NEW_LABREQUESTCALENDAR,
  ADD_LABREQUESTCALENDAR_SUCCESS,
  ADD_LABREQUESTCALENDAR_FAIL,
  UPDATE_LABREQUESTCALENDAR,
  UPDATE_LABREQUESTCALENDAR_SUCCESS,
  UPDATE_LABREQUESTCALENDAR_FAIL,
  DELETE_LABREQUESTCALENDAR,
  DELETE_LABREQUESTCALENDAR_SUCCESS,
  DELETE_LABREQUESTCALENDAR_FAIL,
  SET_STATE_LABREQUESTCALENDAR
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTCALENDAR,
  payload: loading,
})

export const getLabRequestCalendars = ( params ) => ({
  type: GET_LABREQUESTCALENDARS,
  payload: { params },
})

export const getLabRequestCalendarsSuccess = (labRequestCalendars, totalPages, currentPage) => ({
  type: GET_LABREQUESTCALENDARS_SUCCESS,
  payload: { labRequestCalendars:labRequestCalendars, total:totalPages, currentPage:currentPage}
})

export const getLabRequestCalendarsFail = error => ({
  type: GET_LABREQUESTCALENDARS_FAIL,
  payload: error,
})

export const addNewLabRequestCalendar = labRequestCalendar => ({
  type: ADD_NEW_LABREQUESTCALENDAR,
  payload: labRequestCalendar,
})

export const addLabRequestCalendarSuccess = labRequestCalendar => ({
  type: ADD_LABREQUESTCALENDAR_SUCCESS,
  payload: labRequestCalendar,
})  

export const addLabRequestCalendarFail = error => ({
  type: ADD_LABREQUESTCALENDAR_FAIL,
  payload: error,
})

export const updateLabRequestCalendar = labRequestCalendar => ({
  type: UPDATE_LABREQUESTCALENDAR,
  payload: labRequestCalendar,
})

export const updateLabRequestCalendarSuccess = labRequestCalendar => ({
  type: UPDATE_LABREQUESTCALENDAR_SUCCESS,
  payload: labRequestCalendar,
})

export const updateLabRequestCalendarFail = error => ({
  type: UPDATE_LABREQUESTCALENDAR_FAIL,
  payload: error,
})

export const deleteLabRequestCalendar = labRequestCalendar => ({
  type: DELETE_LABREQUESTCALENDAR,
  payload: labRequestCalendar,
})

export const deleteLabRequestCalendarSuccess = id => ({
  type: DELETE_LABREQUESTCALENDAR_SUCCESS,
  id,
})

export const deleteLabRequestCalendarFail = error => ({
  type: DELETE_LABREQUESTCALENDAR_FAIL,
  payload: error,
})

export const getLabRequestCalendar = () => ({
  type: GET_LABREQUESTCALENDAR,
})

export const getLabRequestCalendarSuccess = labRequestCalendar => ({
  type: GET_LABREQUESTCALENDAR_SUCCESS,
  payload: labRequestCalendar,
})

export const getLabRequestCalendarFail = error => ({
  type: GET_LABREQUESTCALENDAR_FAIL,
  payload: error,
})
